import useApi from '~/composables/useApi'
import { formatDate } from '~/utils/dates'
import { capitalize } from '~/utils/functions'

import {
  STORE_BY_SLUG_QUERY,
  STORES_ALL_LAT_LNG_QUERY,
  STORES_BY_FOREIGN_COUNTRY_QUERY,
  STORES_BY_IDS_LIGHT_QUERY,
  STORES_BY_IDS_LIGHT_QUERY_ORDERED,
  STORES_BY_IDS_QUERY,
  STORES_BY_IDS_QUERY_ORDERED,
  STORES_BY_PROVINCE_LIGHT_QUERY,
  // STORES_BY_PROVINCE_QUERY,
  STORES_SEARCH_LIGHT_QUERY
  // STORES_SEARCH_QUERY
} from './index'

function buildQuery (term, fields, operator = 'OR') {
  const fieldQueries = fields.map(field => `${field}:${term}`)
  return fieldQueries.join(` ${operator} `)
}

export async function getStoresByName (name) {
  return (await useApi(STORES_SEARCH_LIGHT_QUERY, { search: buildQuery(name, [ 'title' ]) }, {}))?.entries || []
}

export async function getStoresByProvince (province) {
  return (await useApi(STORES_BY_PROVINCE_LIGHT_QUERY, { province: province }, {}))?.entries || []
}

export async function getStoresByForeignCountry (foreignCountryId) {
  return (await useApi(STORES_BY_FOREIGN_COUNTRY_QUERY, { foreignCountry: [ foreignCountryId ] }, {}))?.entries || []
}

export async function getAllStoresCoords () {
  return (await useApi(STORES_ALL_LAT_LNG_QUERY, {}, {}))?.entries || []
}

export async function getStoresByIds (ids, ordered = false, light = false) {
  let query
  if (light) {
    query = ordered ? STORES_BY_IDS_LIGHT_QUERY_ORDERED : STORES_BY_IDS_LIGHT_QUERY
  } else {
    query = ordered ? STORES_BY_IDS_QUERY_ORDERED : STORES_BY_IDS_QUERY
  }
  return (await useApi(query, { id: ids }, {}))?.entries || []
}

export async function getStoreBySlug (slug, options = {}) {
  const slugArray = Array.isArray(slug) ? slug : [ slug ]
  return (await useApi(STORE_BY_SLUG_QUERY, { slug: slugArray }, options))?.entry || []
}

// Extract HH:mm directly from Craft ISO strings to avoid timezone conversions.
const extractStoreTime = isoStr => {
  if (!isoStr) return ''
  const isoMatch = isoStr.match(/^\d{4}-\d{2}-\d{2}T(\d{2}):(\d{2})/)
  const genericMatch = isoStr.match(/(\d{2}):(\d{2})/)

  const extractedTime = isoMatch
    ? `${isoMatch[1]}:${isoMatch[2]}`
    : genericMatch
      ? `${genericMatch[1]}:${genericMatch[2]}`
      : ''
  return extractedTime
}

export const parseStoreHours = (store, locale, t) => {
  let _hours = ''
  let _sunday = null

  if (store.openingHours?.every(d => Object.values(d).every(dv => dv == null))) {
    _hours = store.textOpeningHours
  } else {
    store.openingHours?.map((d, idx) => {
      const dayname = formatDate(new Date(`2025-06-${`${idx + 1}`.padStart(2, '0')}`), 'EEEE', locale)

      let result = ''
      if (Object.values(d).every(dv => dv == null)) {
        result = `${capitalize(dayname)}: ${t('dealer.info.closed')}`
      } else {
        const morningOpenFormatted = extractStoreTime(d.morningOpen)
        const morningCloseFormatted = extractStoreTime(d.morningClose)
        const afternoonOpenFormatted = extractStoreTime(d.afternoonOpen)
        const afternoonCloseFormatted = extractStoreTime(d.afternoonClose)
        result = `
          ${capitalize(dayname)}: ${morningOpenFormatted ? morningOpenFormatted + ' - ' : ''}
          ${morningCloseFormatted ? morningCloseFormatted + ', ' : ''}
          ${afternoonOpenFormatted ? afternoonOpenFormatted + ' - ' : ''}
          ${afternoonCloseFormatted || ''}
        `
      }

      if (idx == 0) {
        _sunday = result
      } else
        _hours = _hours?.concat(result, '<br />')
    })

    _hours = _hours?.concat(_sunday)
  }

  return {
    ...store,
    openingHours: _hours
  }
}
